
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const SplashScreen = ({ onComplete }) => {
  const [isExpanding, setIsExpanding] = useState(false);

  useEffect(() => {
    // This matches the end of your "Blink Dot" animation (0.7s delay + 0.7s duration = 1.4s)
    const expandTimer = setTimeout(() => setIsExpanding(true), 1400);
    
    return () => clearTimeout(expandTimer);
  }, []);

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-[#EEF2FC] overflow-hidden">
      <AnimatePresence>
        {!isExpanding && (
          <motion.div
            key="brand-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.1 } }} 
            className="flex flex-col items-center"
          >
            {/* Tagline */}
            <div className="overflow-hidden mb-2">
              <motion.p
                initial={{ y: "100%" }}
                animate={{ y: 0 }}
                transition={{ delay: 0.1, duration: 0.4 }}
                className="text-gray-700 tracking-[0.4em] font-medium uppercase text-[10px] md:text-lg"
              >
                Welcome To
              </motion.p>
            </div>

            {/* Main Logo: EUROFOX */}
            <div className="flex items-baseline text-6xl md:text-8xl font-black tracking-tighter uppercase italic relative">
              <motion.span
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.4 }}
                className="text-[#0C4550]"
              >
                EURO
              </motion.span>
              <motion.span
                initial={{ x: 20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.4, duration: 0.4 }}
                className="text-[#F46653]"
              >
                FOX
              </motion.span>

              {/* The Blink Dot */}
              <div className="relative inline-block ml-1 w-4 h-4 md:w-5 md:h-5">
                <motion.span
                  initial={{ scale: 0 }}
                  animate={{ 
                    scale: [0, 1, 0, 1], 
                    opacity: [1, 1, 0, 1] 
                  }}
                  transition={{
                    delay: 0.7,
                    duration: 0.7,
                    times: [0, 0.3, 0.6, 1],
                    ease: "easeInOut",
                  }}
                  className="absolute inset-0 rounded-full bg-[#F46653]"
                />
              </div>
            </div>
            
            {/* Underline */}
            <div className="relative w-full flex justify-center mt-4">
                <motion.div 
                  initial={{ width: 0, opacity: 0 }}
                  animate={{ width: "100%", opacity: 1 }}
                  transition={{ delay: 0.8, duration: 0.6, ease: "easeOut" }}
                  className="relative h-[2px] w-full"
                  style={{
                    background: "linear-gradient(90deg, transparent 0%, #F46653 50%, transparent 100%)",
                    boxShadow: "0px 0px 12px rgba(244, 102, 83, 0.6)"
                  }}
                >
                  <div className="absolute inset-0 bg-white/30 blur-[1px]" />
                </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* The Fast Expansion */}
      <AnimatePresence>
        {isExpanding && (
          <motion.div
            initial={{ 
              scale: 0,
              width: "20px", 
              height: "20px",
              borderRadius: "100%",
              // Centered these for a smoother fill
              x: "80px", 
              y: "15px",
              opacity: 1
            }}
            animate={{ 
              scale: 350, 
              borderRadius: "0%" 
            }}
            transition={{
              duration: 0.5, // Slightly faster for snappiness
              ease: [0.7, 0, 0.3, 1],
            }}
            // CRITICAL CHANGE: Triggers the page appearance the millisecond the scale finishes
            onAnimationComplete={() => {
              if (onComplete) onComplete();
            }}
            className="absolute bg-[#0C4550] z-50 pointer-events-none"
            style={{ 
                transformOrigin: "center center"
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default SplashScreen;